import axios from 'axios';


/**
 * @param {Object} Vue
 * @param {Object} options {api}
 *
 * @return {Object} apiOperation
 */
export default (Vue, {apiOperation: globalAxiosOptions}) => {
  const apiAxios = axios.create({
    method: 'POST',
    baseURL: '/api/exec-operation',
    ...globalAxiosOptions
  });

  const beforeResponse = (config) => config;

  const responseError = async (error) => {
    if (error.response && error.response.status === 401) {
      await Vue.auth.verifyUser();
    }
    return Promise.reject(error);
  };

  apiAxios.interceptors.response.use(beforeResponse, responseError);


  /**
   * Generate request against `/api/exec-operation/${operationId}`
   * @param {string} operationId
   * @param {Object} requestOptions {parameters, requestBody}
   * @param {Object} axiosOptions
   */
  const apiOperation = async (operationId, requestOptions, axiosOptions) => {
    requestOptions = requestOptions || {};
    axiosOptions = axiosOptions || {};

    const {parameters, requestBody} = requestOptions;
    const data = parameters || requestBody ? {parameters, requestBody} : null;

    return await apiAxios({
      url: operationId,
      data,
      ...axiosOptions
    });
  };

  Vue.apiOperation = apiOperation;

  return apiOperation;
};
